<template>
  <div>
    <div class="add-box">
      <div ref="imgbox" v-if="uploadList && viewType" class="upload-list2-wrap">
        <div class="upload-list2" v-for="(item,index) in uploadList" :key="index">
          <span
            class="pdf-box2"
            v-if="/(.pdf)$/i.test(item.url)"
            @click="clickFile(item.url)"
          >{{item.oldFileName}}</span>
          <span v-else>
            <img :data-original="`${item.url}`" :src="item.url" />
          </span>
          <div class="upload-list2-cover">
            <Icon type="md-remove" @click.native="handleRemove(index)"></Icon>
          </div>
        </div>

        <Upload
          ref="upload"
          :show-upload-list2="false"
          multiple
          :before-upload="handleUpload"
          :on-success="loadfile"
          :action="actionUrl"
          :headers="uploadHeaders"
          style="display: inline-block;width:180px; height:180px;"
        >
          <div class="file-upload-box2">
            <Icon type="md-add" size="20"></Icon>
          </div>
        </Upload>
      </div>

      <div ref="imgbox" v-if="uploadList && !viewType">
        <div class="upload-list2" v-for="(item,index) in uploadList" :key="index">
          <span
            class="pdf-box2"
            v-if="/(.pdf)$/i.test(item.url)"
            @click="clickFile(item.url)"
          >{{item.oldFileName}}</span>
          <span v-else>
            <img :data-original="`${item.url}`" :src="item.url" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";

export default {
  name: "UploadImg",
  props: {
    viewType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      viewer: null,
      uploadList: [],
      uuidList: [],
      fileList: [],
      fileVisible: false,
      file: null, // 上传
      actionUrl: "", // 初始化上传地址
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
    };
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  methods: {
    setList(addUrlList) {
      this.destroyViewer();
      this.uploadList = addUrlList;
      this.$nextTick(() => {
        this.initImageTools();
      });
    },
    clickFile(url) {
      window.open(url);
    },
    handleUpload(file) {
      // 上传
      this.file = file;
      // this.uploadList = this.$refs.upload.fileList;
      let that = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        that.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);
      console.log(this.file.name);
    },
    handleRemove(i) {
      // const fileList = this.$refs.upload.fileList;
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          console.log(i);
          this.uploadList.splice(i, 1);
          this.$emit("fileList", this.uploadList);
        }
      });
    },
    loadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.uploadList.push(obj);
        this.$emit("fileList", this.uploadList);
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    destroyViewer() {
      this.viewer ? this.viewer.destroy() : "";
    },
    initImageTools() {
      //初始化 viewerjs
      const ViewerDom = this.$refs.imgbox;
      this.viewer = new Viewer(ViewerDom, {
        url: "data-original",
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          reset: 1,
        },
        show: function () {
          this.viewer.update();
        },
      });
    },
  },
};
</script>

<style>
.upload-list2-wrap {
  display: flex;
  flex-wrap: wrap;
}

.upload-list2 {
  display: inline-block;
  width: 180px;
  height: 180px;
  text-align: center;
  line-height: 180px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-left: 4px;
  vertical-align: middle;
  margin-bottom: 10px;
}

.upload-list2 img {
  width: 100%;
  height: 100%;
  border-style: none;
}

.add-box .file-upload-box2 {
  height: 180px;
  width: 180px;
  line-height: 180px;
  border: 1px dashed #dcdee2;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.upload-list2:hover .upload-list2-cover {
  display: block;
}

.upload-list2-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.upload-list2-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}
.upload-list2 .pdf-box2 {
  height: 180px;
  width: 180px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
</style>